// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module__root___dJSnX","inclusionTypeIcon":"styles-module__inclusionTypeIcon___sDA4R"};